import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError } from 'react-jsonschema-form'
import {
    PaymentSource,
    getPaymentSourceText,
    PaymentType,
    getPaymentTypeText,
    PaymentDirection,
    getPaymentDirectionText
} from './Payment'
import UserStore from '../Stores/UserStore'

const ls = LocalizationStore.getInstance()

export interface IPaymentForm {
    externalDataSourceType: number
    creditNumberPaymentPrefill: string
    amountPrefill: string
}

export class PaymentForm implements IPaymentForm {
    externalDataSourceType: number
    creditNumberPaymentPrefill: string
    amountPrefill: string
}

export const enum ExternalDataSourceType {
    Magnit = 0,
    Sky = 1,
    SRS = 2
}

export function getExternalDataSourceTypeText(externalDataSourceType: ExternalDataSourceType) {
    switch (externalDataSourceType) {
        case ExternalDataSourceType.Magnit:
            return ls.t('Magnit')
        case ExternalDataSourceType.Sky:
            return ls.t('Sky')
        case ExternalDataSourceType.SRS:
            return ls.t('SRS')
        default:
            return ls.t('None')
    }
}

export function getPaymentPrefillFormSchema(): any {
    return {
        'title': ls.t!('Add payment'),
        'type': 'object',
        'required': [
            'externalDataSourceType',
            'creditNumberPaymentPrefill',
            'amountPrefill'
        ],
        'properties': {
            paymentDirection: {
                title: ls.t!('paymentDirection'),
                type: 'number',
                enum: [
                    PaymentDirection.Deposit,
                    PaymentDirection.Withdrawal,
                ],
                enumNames: [
                    getPaymentDirectionText(PaymentDirection.Deposit),
                    getPaymentDirectionText(PaymentDirection.Withdrawal),
                ],
                default: PaymentDirection.Deposit.toString()
            },
            externalDataSourceType: {
                title: ls.t!('ExternalDataSourceType'),
                type: 'number',
                enum: [
                    ExternalDataSourceType.SRS,
                    ExternalDataSourceType.Sky,
                    ExternalDataSourceType.Magnit
                ],
                enumNames: [
                    getExternalDataSourceTypeText(ExternalDataSourceType.SRS),
                    getExternalDataSourceTypeText(ExternalDataSourceType.Sky),
                    getExternalDataSourceTypeText(ExternalDataSourceType.Magnit),
                ],
                default: ExternalDataSourceType.SRS
            },
            'creditNumberPaymentPrefill': {
                'title': ls.t!('creditNumberPaymentPrefill'),
                'type': 'string'
            },
            'amountPrefill': {
                'title': ls.t!('paymentAmount'),
                'type': 'number',
            },

            // paymentStatus: {
            //     title: ls.t!('paymentStatus'),
            //     type: 'number',
            //     enum: [
            //         PaymentStatus.Canceled,
            //         PaymentStatus.Done,
            //         PaymentStatus.New,
            //         PaymentStatus.Pending
            //     ],
            //     enumNames: [
            //         getPaymentStatusText(PaymentStatus.Canceled),
            //         getPaymentStatusText(PaymentStatus.Done),
            //         getPaymentStatusText(PaymentStatus.New),
            //         getPaymentStatusText(PaymentStatus.Pending),
            //     ],
            //     default: PaymentStatus.Done.toString(),
            // },
            paymentSource: {
                title: ls.t!('paymentSource'),
                type: 'number',
                enum: [
                    PaymentSource.Cash,
                    PaymentSource.Virtual,
                    PaymentSource.VirtualFix,
                    PaymentSource.BankOfBaku,
                    PaymentSource.KapitalBank,
                    PaymentSource.Unibank,
                    PaymentSource.MillionManual
                ],
                enumNames: [
                    getPaymentSourceText(PaymentSource.Cash),
                    getPaymentSourceText(PaymentSource.Virtual),
                    getPaymentSourceText(PaymentSource.VirtualFix),
                    getPaymentSourceText(PaymentSource.BankOfBaku),
                    getPaymentSourceText(PaymentSource.KapitalBank),
                    getPaymentSourceText(PaymentSource.Unibank),
                    getPaymentSourceText(PaymentSource.MillionManual),
                ],
                default: PaymentSource.Cash.toString()
            },
            paymentType: {
                title: ls.t!('paymentType'),
                type: 'number',
                enum: [
                    PaymentType.MonthlyPayment,
                    PaymentType.Prepayment,
                    PaymentType.Penalty,
                ],
                enumNames: [
                    getPaymentTypeText(PaymentType.MonthlyPayment),
                    getPaymentTypeText(PaymentType.Prepayment),
                    getPaymentTypeText(PaymentType.Penalty),
                ],
                default: PaymentType.MonthlyPayment.toString()
            },
            paymentDateTime: {
                title: ls.t('paymentDateTime'),
                type: 'string', // Attention! date-time
                format: 'date-time',
                default: new Date()
            }
        }
    }
}

export function getUIPaymentPrefillFormSchema() {
    const us = UserStore.getInstance()

    if (us.checkCashier) {
        return {
            // paymentStatus:
            // {
            //     'ui:enumDisabled': [PaymentStatus.Canceled,
            //     PaymentStatus.New,
            //     PaymentStatus.Pending],
            // },
            paymentSource:
            {
                'ui:enumDisabled': [PaymentSource.Virtual, PaymentSource.VirtualFix, PaymentSource.MillionManual],
            }
        }
    } else if (us.checkAdmin || us.checkCashierAdmin || us.checkSuperAdmin) {
        return
    }

    // console.error('User doesn`t have permissions to create payment')
    return
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        return error
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/PaymentPrefillForm.tsx